module.exports = __webpack_public_path__ + "img/GERA_Intranet_Mobile_Team_03.jpg";